<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="background: url('/static/img/default_header.png'); background-position: top !important;"
        ></div>
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">{{ $t("venues") }}</div>
          </div>
        </div>
      </div>
    </div>

    <Breadcrumb />

    <div>
      <div class="mx-0 row align-items-start cp_wrapper">
        <!-- Left Area -->
        <div class="col-xl-9 px-0">
          <div class="mx-0 pa-0 text-content">
            <v-expansion-panels v-model="open" multiple>
              <div class="cp_wrap">
                <v-expansion-panel
                  v-show="sortedVenues[tenant.id].length != 0"
                  v-for="(tenant, i) in tenants"
                  :key="i"
                  class="py-1 pl-8 pl-md-12"
                >
                  <v-expansion-panel-header class="pl-8 py-1 pl-md-12">
                    <h6 class="text-md-h6 mb-0">
                      {{ tenant.name }}
                    </h6>
                    <template v-slot:actions>
                      <div>
                        <img
                          v-bind:class="open.includes(i) ? 'panelarrow_up' : 'panelarrow_down'"
                          class="ml-2 clickable"
                          src="../assets/img/arrow_right.svg"
                          height="18px"
                        />
                      </div>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      v-bind:class="sortedVenues[tenant.id].length > 2 ? 'justify-content-between' : ''"
                      class="d-flex g-space-15"
                    >
                      <div
                      @click="$router.push('/venue?venueId=' + venue.id)"
                        class="venue_block col-md-4 p-0 justify-content-center"
                        v-for="venue in sortedVenues[tenant.id]"
                        :key="venue.id"
                      >
                        <div class="block-tile col-md-12 clickable sixteentonine">
                          <div
                            class="kachelimage block-background-image"
                            :style="{
                              'background-image': 'url(\'/files/images/' + venue.image + '\')',
                            }"
                          ></div>
                          <div class="py-1 pr-2 pl-2 pl-md-6 bottom-row bg-blue">
                            {{ venue.designation }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </div>
            </v-expansion-panels>
          </div>
        </div>

        <!-- Right Area -->
        <div class="col-xl-3 pl-8 pl-md-12 pl-xl-8 row">
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "./custom/pagination.vue";
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    pagination,
    Breadcrumb,
  },

  data() {
    return {
      tenants: [],
      venues: [],
      sortedVenues: [],
      contactPersons: [],
      selectedTenantPanel: null,
      open: [], // expansion panels open model
    };
  },

  mounted() {
    this.fetchVenues();
  },

  methods: {
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },

    fetchVenues() {
      var _this = this;
      this.$axios
        .get("/api/location/fetchAllLocations")
        .then(function (response) {
          _this.venues = response.data;
          _this.tenants = [];

          for (let i = 0; i < _this.venues.length; i++) {
            const venue = _this.venues[i];

            if (venue.tenant == null) continue;

            // Add unique tenant
            if (!_this.tenants.some((t) => t.id === venue.tenant.id)) {
              _this.tenants.push(venue.tenant);
            }
          }

          // Reset panels
          _this.resetOpenPanels();

          _this.sortVenues();
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },

    sortVenues() {
      const sortedVenues = [];
      for (const tenant of this.tenants) {
        sortedVenues[tenant.id] = [];
      }

      for (const venue of this.venues) {
        if (!venue.tenant) continue;
        if (sortedVenues[venue.tenant.id]) {
          sortedVenues[venue.tenant.id].push(venue);
        }
      }

      this.sortedVenues = sortedVenues;
    },

    resetOpenPanels() {
      this.open = this.tenants.length > 0 ? [0] : [];
    },
  },

  watch: {
    '$i18n.locale'(newLocale, oldLocale) {
      // Whenever the language changes, re-open the first panel
      this.resetOpenPanels();
    },
  },
};
</script>
